import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import classnames from 'classnames';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { WIZARD_STEPS } from '../../../redux/collect-sizes/collect-sizes.reducer';
import { CollectionNameDialog } from './components/collection-name-dialog';
import { GeneratedLinkDialog } from './components/generated-link-dialog';
import { GreetingsDialog } from './components/greetings-dialog';
import css from './collect-sizes-popup.scss';
export const classes = {
  paper: css.paper
};
export const titleClasses = {
  root: css.popupHeader
};
const WIZARD_STEP_DIALOG = {
  [WIZARD_STEPS.GREETINGS]: /*#__PURE__*/React.createElement(GreetingsDialog, null),
  [WIZARD_STEPS.COLLECTION_NAME]: /*#__PURE__*/React.createElement(CollectionNameDialog, null),
  [WIZARD_STEPS.GENERATED_LINK]: /*#__PURE__*/React.createElement(GeneratedLinkDialog, null)
};
const animationClasses = {
  enter: css.enter,
  enterActive: css.enterActive,
  exit: css.exit,
  exitActive: css.exitActive
};
export const CollectSizesPopup = ({
  open,
  step,
  isLimitedEdition,
  onClose
}) => {
  const content = /*#__PURE__*/React.createElement("div", {
    className: css.animatedContent
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: step,
    timeout: 200
  }, WIZARD_STEP_DIALOG[step])));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: onClose,
    dataPopup: "CollectSizesPopup",
    content: content,
    classes: classes,
    titleHeader: css.popupHeader,
    titleClasses: titleClasses,
    contentClass: css.contentWrapper,
    closeClass: classnames(css.closeClass, {
      [css.closeClassLE]: isLimitedEdition
    }),
    isResponsive: true
  });
};